<template>
    <div class="page">
        <panel
            ref="panel"
            :wapTitle="title"
            :appLink="appLink"
            :spreadID="spreadID"
            :showNav="'true'"
            @gotoApp="gotoApp"
            :isApp="false"
        ></panel>
        <!-- 选择日期 -->
        <div class="option-time">
            <div class="start-time" @click="startdatatime">
                {{ startTitle }}
            </div>
            <span>至</span>
            <div class="end-time" @click="enddatatime">{{ endTitle }}</div>
        </div>
        <!-- {{ currentDate }} -->
        <!-- 选择开始年月日 -->
        <van-popup
            v-model="startdatatimeopen"
            position="bottom"
            :style="{ width: '100%'}"
        >
            <!-- 选择开始年月日 -->
            <van-datetime-picker
                class="datatime"
                v-model="currentstartDate"
                type="date"
                title="选择年月日"
                :min-date="minDate"
                :max-data="maxData"
                @confirm="startqueren"
                @cancel="startdatatimeopen = false"
            >
            </van-datetime-picker>
        </van-popup>
        <!-- 选择结束时间 -->
        <van-popup v-model="enddatatimeopen"
                   position="bottom"
                   :style="{ width: '100%'}">
            <van-datetime-picker
                class="datatime"
                v-model="currentendDate"
                type="date"
                title="选择年月日"
                :min-date="currentstartDate ? currentstartDate : minDate"
                :max-date="maxData"
                @confirm="endqueren"
                @cancel="enddatatimeopen = false"
            >
            </van-datetime-picker>
        </van-popup>

        <!-- 热门拍卖公司 -->
        <div class="hot-company">
            <div class="hot-company-top">热门拍卖公司</div>
            <div class="hot-company-contents">
                <ul>
                    <!--  :class="index % 2 == 0 ? 'active' : ''"    选中的状态class类名 -->
                    <li
                        ref="box"
                        @click="clickComponent(item, index)"
                        v-for="(item, index) in hotList"
                        :class="{'active':item.organCode==selectList}"
                        :key="index"
                    >
                        {{ item.name }}
                    </li>
                </ul>
            </div>
        </div>
        <!-- 自定义索引字符列表 -->
        <div class="index-list" highlight-color="#e7e7e7">
            <van-index-bar :index-list="indexList">
                <template v-for="(item, index) in cityList">
                    <van-index-anchor :key="index">{{
                        item.l
                    }}</van-index-anchor>
                    <van-cell
                        ref="city"
                        @click="letterjj(sItem,$event)"
                        v-for="sItem in item.list"
                        :key="sItem.name"
                        ><div class="cityName" :class="{'curr':decodeURIComponent(cityparam) == sItem.name}">{{ sItem.name }}</div></van-cell
                    >
                </template>
            </van-index-bar>
        </div>
        <!-- 底部 -->
        <div class="footer">
            <div class="reset" @click="resest">重置</div>
            <div class="finish" @click="finishClick">完成</div>
        </div>
        <DownLoadApp ref="downloadPop"></DownLoadApp>
        <watermark v-if="showWater"></watermark>
    </div>
</template>

<script>
import { IndexBar, IndexAnchor,Popup } from "vant";
import { aucList, recomm,getTime } from "@/api/auction";
import panel from "@/views/preview/component/panel.vue";
import DownLoadApp from "@/components/common/downloadApp";
import { mapActions, mapGetters } from "vuex";
import { getWXConfig } from "@/assets/js/weixinShare";
import watermark from "@/components/common/watermark";

export default {
    data() {
        return {
            showWater: false,
            waterLink: "",
            param: {
                citys: "",
                keyword: "",
                page: 1,
                status: 0, //拍卖预展0  拍卖结果1
                type: 0,
                only_meta: 1,
            },
            keyWorlds: {
                citys: "",
                keyword: "",
                page: 1,
                status: 0, //拍卖预展0  拍卖结果1
                type: 0,
            },
            startTitle: this.$route.query.startTime ? this.$route.query.startTime : "拍卖开始日期",
            endTitle: this.$route.query.endTime ? this.$route.query.endTime : "拍卖结束日期",
            cityparam: this.$route.query.cityparam ? this.$route.query.cityparam : '', //城市参数
            startTime: this.$route.query.startTime ? this.$route.query.startTime : "", //开始时间参数
            endTime: this.$route.query.endTime ? this.$route.query.endTime : "", //结束时间参数
            startdatatimeopen: false,
            enddatatimeopen: false,
            selectList: this.$route.query.selectList ? this.$route.query.selectList : '', //热门城市的选中城市
            cityList: [],
            hotList: [],
            title: "筛选",
            appLink: "/2/8/0",
            minDate:'',
            maxData:'',
            spreadID: 0,
            indexList: [
                "全部",
                "A",
                "B",
                "C",
                "D",
                "E",
                "F",
                "G",
                "H",
                "I",
                "J",
                "K",
                "L",
                "M",
                "N",
                "O",
                "P",
                "Q",
                "R",
                "S",
                "T",
                "U",
                "V",
                "W",
                "X",
                "Y",
                "Z",
            ],
            dataList: [
                {
                    index: "A",
                    list: ["鞍山", "ajdkj"],
                },
                { index: "B", list: ["鞍山", "ajdkj"] },
                { index: "C", list: ["鞍山", "ajdkj"] },
                { index: "D", list: ["鞍山", "ajdkj"] },
                { index: "E", list: ["鞍山", "ajdkj"] },
                { index: "F", list: ["鞍山", "ajdkj"] },
                { index: "G", list: ["鞍山", "ajdkj"] },
                { index: "H", list: ["鞍山", "ajdkj"] },
                { index: "I", list: ["鞍山", "ajdkj"] },
                { index: "J", list: ["鞍山", "ajdkj"] },
                { index: "K", list: ["鞍山", "ajdkj"] },
                { index: "L", list: ["鞍山", "ajdkj"] },
                { index: "M", list: ["鞍山", "ajdkj"] },
                { index: "N", list: ["鞍山", "ajdkj"] },
                { index: "O", list: ["鞍山", "ajdkj"] },
                { index: "P", list: ["鞍山", "ajdkj"] },
                { index: "Q", list: ["鞍山", "ajdkj"] },
                { index: "R", list: ["鞍山", "ajdkj"] },
                { index: "S", list: ["鞍山", "ajdkj"] },
                { index: "T", list: ["鞍山", "ajdkj"] },
                { index: "U", list: ["鞍山", "ajdkj"] },
                { index: "V", list: ["鞍山", "ajdkj"] },
                { index: "W", list: ["鞍山", "ajdkj"] },
                { index: "X", list: ["鞍山", "ajdkj"] },
                { index: "Y", list: ["鞍山", "ajdkj"] },
                { index: "Z", list: ["鞍山", "ajdkj"] },
            ],
            currentstartDate: '',
            currentDate: '',
            currentendDate: false,
        };
    },
    components: {
        "van-index-bar": IndexBar,
        "van-index-anchor": IndexAnchor,
        DownLoadApp,
        panel,
        watermark,
        'van-popup':Popup,
    },
    asyncData({ store }) {
        // console.log(store, 33333);
        let dataJSON = {
            citys: "",
            keyword: "",
            page: 1,
            status: 0, //拍卖预展0  拍卖结果1
            type: 0,
            only_meta: 1,
        };
        return store.dispatch("pageSelect/getaucListSelect", [
            dataJSON,
            () => {},
        ]);
    },
    created() {
        this.getaucList();
        this.getrecomm();
    },
    computed: {
        ...mapGetters({
            getIsLoadIng: "pageSelect/getIsLoadIng",
            getData: "pageSelect/getData",
        }),
    },
    mounted() {
        if (this.$route.query.from && this.$route.query.from == 1||this.$route.query.from == 2) {
            this.showWater = true;
            this.waterLink = this.$route.query.from;
        }
        if (!this.getIsLoadIng) {
            this.getaucListSelect([
                this.param,
                () => {
                    this.filteData();
                },
            ]);
        } else {
            // console.log("服务端调用",this.param);
            this.filteData();
        }
        this.getTime()
    },
    methods: {
        getTime(){
            getTime().then((res) => {
                if(res.code == 0){
                    let time = res.data.time_unix
                    this.currentstartDate = new Date(time*1000)
                    this.currentDate = new Date(time*1000)
                    this.formatTime(time)
                }
            })
        },
        formatTime(t){
            let time = new Date(t*1000)
            this.minDate = new Date(time.getFullYear()-10,time.getMonth(),time.getDate());
            this.maxData = new Date(time.getFullYear()+10,time.getMonth(),time.getDate())
        },
        gotoApp() {
            this.$refs.downloadPop.gotoAppDownload(this.appLink, 0);
        },
        ...mapActions({
            getaucListSelect: "pageSelect/getaucListSelect",
        }),
        filteData() {
            // 微信分享+title
            let dome = this.$store.state["pageSelect"]["data"];
            document.title = dome.meta ? dome.meta.title : "";
            let head = document.getElementsByTagName("head");
            if (!document.querySelector("meta[name=description]")) {
                let meta = document.createElement("meta");
                meta.name = "description";
                meta.content = dome.meta ? dome.meta.description : "";
                head[0].appendChild(meta);
            } else {
                document
                    .querySelector("meta[name=description]")
                    .setAttribute(
                        "content",
                        dome.meta ? dome.meta.description : ""
                    );
            }
            window.AFedWxShareData = {
                title: dome.meta ? dome.meta.shareTitle : "",
                imgUrl:
                    dome.meta.pic ||
                    "https://pubunder.artron.net/pubimgs/m/wxImgAuc.png",
                desc: dome.meta.description || "",
                link: window.location.href,
            };
            getWXConfig(window.AFedWxShareData);
        },
        // 选择热门公司
        clickComponent(item, index) {
            // 选中状态添加类名active
            if (this.selectList != item.organCode) {
                this.selectList = item.organCode;
                this.$refs.box[index].classList.add("active");
                this.hotList.forEach((m, i) => {
                    if (i != index) {
                        return this.$refs.box[i].classList.remove("active");
                    }
                });
            } else {
                this.selectList = item.organCode;
            }
        },
        // 点击城市按钮
        letterjj(j,e) {
            let target = e.target
            let obj = document.getElementsByClassName('cityName');
            for(let i=0;i<obj.length;i++){
                obj[i].classList.remove('curr')
            }
            target.classList.add('curr')
            this.cityparam = encodeURIComponent(j.name == '全部' ? '' : j.name);
        },
        // 开始时间确认按钮
        startqueren(value) {
            this.startdatatimeopen = false;
            // var datetime=value.getFullYear() + '-' + (value.getMonth() + 1) + '-' + value.getDate() + ' ' + value.getHours() + ':' + value.getMinutes() + ':' + value.getSeconds();
            // 时间格式化
            var datetime =
                value.getFullYear() +
                "-" +
                this.formatDay((value.getMonth() + 1)) +
                "-" +
                this.formatDay(value.getDate());
            this.startTitle = datetime;
            this.startTime = datetime;
        },
        // 结束时间确认按钮
        endqueren(value) {
            this.enddatatimeopen = false;
            // var datetime=value.getFullYear() + '-' + (value.getMonth() + 1) + '-' + value.getDate() + ' ' + value.getHours() + ':' + value.getMinutes() + ':' + value.getSeconds();
            //  时间格式化
            var datetime =
                value.getFullYear() +
                "-" +
                this.formatDay(value.getMonth() + 1) +
                "-" +
                this.formatDay(value.getDate());
            this.endTitle = datetime;
            this.endTime = datetime;
        },
        formatDay(num){
            return num < 10 ? '0'+num : num
        },
        // 开始时间点击事件
        startdatatime() {
            this.startdatatimeopen = !this.startdatatimeopen;
            // document.body.style.backgroundColor = "rgba(0,0,0,0.3)";
        },
        // 结束时间点击事件
        enddatatime() {
            this.enddatatimeopen = !this.enddatatimeopen;
            // document.body.style.backgroundColor = "rgba(0,0,0,0.3)";
        },
        // 重置
        resest() {
            this.startTitle = "拍卖开始日期";
            this.endTitle = "拍卖结束日期";
            this.startTime = "";
            this.endTime = "";
            this.selectList = '';
            this.cityparam = '';
            this.hotList.forEach((m, i) => {
                this.$refs.box[i].classList.remove("active");
            });
            let obj = document.getElementsByClassName('cityName');
            for(let i=0;i<obj.length;i++){
                obj[i].classList.remove('curr')
            }

        },
        // 完成
        finishClick() {
            this.$router.push({
                path: "/preview",
                query: {
                    active: this.$route.query.active,
                    startTime: this.startTime,
                    endTime: this.endTime,
                    selectList: this.selectList,
                    cityparam: this.cityparam,
                    from:this.waterLink
                },
            });
        },
        // 返回按钮
        goBack() {
            if(window.history.state){
                this.$router.back();
            }else{
                this.$router.push({path:'/'})
            }
            this.startTitle = "拍卖开始日期";
            this.endTitle = "拍卖结束日期";
            this.startTime = "";
            this.endTime = "";
            this.selectList = {};
            this.cityparam = {};
        },
        // 热门拍卖公司接口列表
        getrecomm() {
            recomm().then((res) => {
                if (res.code == 0) {
                    this.hotList = res.data.dataList;
                }
            });
        },
        // 城市列表接口
        getaucList() {
            aucList(this.keyWorlds).then((res) => {
                if (res.code == 0) {
                    this.cityList = res.data.cityList;
                }
            });
        },
    },
};
</script>

<style scoped>
@import url("../../assets/css/index.css");
@import url("../../assets/css/reset.css");
.option-time {
    width: 18.75rem;
    height: 3.8rem;
    margin: 0 auto;
    background: #f7f7f7;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.option-time .start-time,
.option-time .end-time {
    width: 6.2rem;
    height: 1.8rem;
    background: #ffffff;
    border-radius: 0.2rem;
    border: 0.05rem solid #dddee3;
    font-size: 0.7rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #27282d;
    display: flex;
    justify-content: center;
    align-items: center;
}
.option-time .start-time {
    margin-left: 1.8rem;
}
.option-time .end-time {
    margin-right: 1.8rem;
}
.option-time span {
    font-size: 0.7rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #27282d;
}

.hot-company {
    width: 18.75rem;
    margin: 0 auto;
    /* height: 8.55rem; */
    background: #ffffff;
    padding: 0.75rem;
}
.hot-company .hot-company-top {
    height: 1.1rem;
    font-size: 0.8rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #27282d;
    line-height: 1.1rem;
    margin-bottom: 0.75rem;
}
.hot-company .hot-company-contents {
    /* background-color: #FFFFFF; */
}
.hot-company .hot-company-contents ul {
    overflow: hidden;
    /* background-color: #FFFFFF; */
}
.hot-company .hot-company-contents li {
    float: left;
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
    padding: 0.2rem 0.5rem;
    height: 1.5rem;
    background: #f7f7f7;
    border-radius: 0.7rem;
    font-size: 0.7rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #27282d;
    display: flex;
    justify-content: center;
    align-items: center;
}
.hot-company .hot-company-contents li.active {
    background: #e2f3eb;
    color: #18bd6f;
}

/* 底部 */
.footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 18.75rem;
    margin: 0 auto;
    height: 3rem;
    background: #ffffff;
    box-shadow: 0rem -0.1rem 0.5rem 0rem rgba(0, 0, 0, 0.1);
    display: flex;
    padding: 0 0.75rem;
    align-items: center;
    justify-content: space-between;
}
.footer .reset {
    width: 5.2rem;
    height: 2.2rem;
    background: #ffffff;
    box-shadow: 0rem -0.1rem 0.5rem 0rem rgba(0, 0, 0, 0.1);
    border-radius: 0.2rem;
    border: 0.05rem solid #dddee3;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.8rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #27282d;
    line-height: 0.9rem;
    text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
}
.footer .finish {
    width: 11.5rem;
    height: 2.2rem;
    background: #18bd6f;
    box-shadow: 0rem -0.1rem 0.5rem 0rem rgba(0, 0, 0, 0.1);
    border-radius: 0.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.8rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 1.1rem;
    text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
}
/* 索引列表 */
.index-list {
    margin-bottom: 3rem;
    margin: 0 auto;
    width: 18.75rem;
    padding-bottom: 3rem;
}
.van-index-bar__index {
    font-size: 0.55rem;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #27282d;
}
.van-index-anchor {
    font-size: 0.6rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
}
.van-index-anchor {
    width: 18.75rem;
    height: 1.25rem;
    background: #e7e7e7;
    display: flex;
    align-items: center;
}
.van-cell {
    width: 18.75rem;
    background: #ffffff;
    font-size: 0.75rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #969696;
    line-height: 1.05rem;
    padding:.45rem .75rem;
}
/deep/.van-index-bar__index--active{color:#18BD6F;}
/* .van-index-bar {
	position: relative;
}
.van-index-bar__sidebar {
	position: absolute;
	top: 50%;
} */
.van-index-bar__sidebar {
    right: -0.4rem;
}

/* 选择时间 */
.datatime {
    z-index: 100;
}
/deep/.van-cell__value--alone{color:#969696;font-size: .75rem;}
/deep/.van-cell .curr{color:#18BD6F;}
/deep/.van-index-anchor{color:#666;font-size: .6rem;background-color: #E7E7E7;line-height: 1.25rem;padding:0 .75rem;}
/deep/.van-cell:after{right:.75rem;left:.75rem;border-bottom-color: #DDDEE3;}
/deep/.van-index-bar__sidebar{transform: translateY(-45%);}
</style>